module.exports = __webpack_public_path__ + "static/img/heroimage_new_card.ca040ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heroimage_new_card.png
// module id = 791
// module chunks = 1